<template>
  <div class="tab tab-notes">
    <h4>Notes collaboratives</h4>
    <VTextarea
      name="notes"
      placeholder="Quelques notes personnelles sur ce talent..."
      rows="4"
      :maxlength="200"
      v-model="state.comment"
    />
    <div class="input-inline">
      <!-- <VField name="note" placeholder="Ajouter une nouvelle note" />
      <Button label="Envoyer ma note" class="primary" /> -->
      <Button label="Modifier" class="primary" @click="saveNote()" />
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRoute } from "vue-router";
import { useParticipantStore } from "@/stores/participant.js";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";

const route = useRoute();

const participantStore = useParticipantStore();

const toast = useToast();

const props = defineProps({
  currentCandidate: {
    type: Object,
    required: true,
  },
});

const state = reactive({
  comment: props.currentCandidate.user_comment,
});

async function saveNote() {
  const resp = await participantStore.commentParticipant(
    route.params.companyId,
    route.params.spaceId,
    route.params.campaignId,
    props.currentCandidate.participant_id,
    state.comment
  );

  if (!resp.code) {
    toast.success("Informations sauvegardées avec succès.");
  } else {
    toast.error(getError(resp.key));
  }
}
</script>
